import Image from "next/image";
import {
  CollegeHaiWhiteLogo,
  FbSvg,
  InstagramSvg,
  LinkedinSvg,
  TwitterSvg,
  YoutubeSvg,
} from "@/src/Asset";
import Link from "next/link";
import ListData from "./components/ListData";
import {
  FB_LINK,
  IG_LINK,
  LINKEDIN_LINK,
  TWITTER_LINK,
  YT_LINK,
} from "@/src/api/apiConstant";
import footerdata  from "../../Shared/Footer/components/footerdata.json";


const quickLinks = [{ href: "/contact-us", text: "Contact Us" }];

export default function Footer() {
//   if (!data) {
//     return (
//       <footer className="row-start-3 flex gap-6 flex-wrap items-center justify-center bg-white text-black w-full h-20">
//         <p>Footer Section. loading ....</p>
//       </footer>
//     );
//   }

  return (
    <footer className="bg-primary">
      <div className="flex flex-col max-w-screen-xl mx-auto sticky bottom-0 bg-primary px-2 md:px-4 py-4 text-white pb-16 md:pb-5 ">
        {/* Subscribe news letter */}

        {/* <SubscibeNewsLetter
        handleSubmit={handleSubmit}
        loading={loading}
        message={message}
        showMessage={showMessage}
        setSubscriptionMode={setSubscriptionMode}
        subscriptionMode={subscriptionMode}
        inputValue={inputValue}
        setInputValue={setInputValue}
        isInputValid={isInputValid}
        setIsInputValid={setIsInputValid}
      /> */}

        <ListData {...footerdata} />

        {/* quick links */}
        <div className="flex md:flex-row flex-col justify-between items-center mt-5 mb-1.5 lg:-ml-5">
          <div>
            <Image
              src={CollegeHaiWhiteLogo}
              alt="footer image"
              width={500}
              height={500}
              className="object-cover object-center w-44 h-14"
            />
          </div>
          <div className="flex justify-between items-center gap-x-5 md:my-0 my-4">
            {quickLinks?.map((link) => (
              <Link
                key={link?.text}
                href={link.href}
                className="text-sm text-white font-light"
              >
                {link.text}
              </Link>
            ))}
          </div>
          <div className="flex justify-between items-center gap-3">
            <Link
              rel="nofollow"
              href={FB_LINK}
              className="bg-white rounded-full p-1 text-black"
              aria-label="Visit CollegeHai on Facebook"
            >
              <FbSvg />
            </Link>
            <Link
              rel="nofollow"
              href={IG_LINK}
              className="bg-white rounded-full p-1 text-black"
              aria-label="Visit CollegeHai on Instagram"
            >
              <InstagramSvg />
            </Link>
            <Link
              rel="nofollow"
              href={YT_LINK}
              className="bg-white rounded-full p-1 text-black"
              aria-label="Visit CollegeHai on YouTube"
            >
              <YoutubeSvg />
            </Link>
            <Link
              rel="nofollow"
              href={TWITTER_LINK}
              className="bg-white rounded-full text-black"
              aria-label="Visit CollegeHai on X (formerly Twitter)"
            >
              <TwitterSvg className="scale-50" />
            </Link>

            <Link
              rel="nofollow"
              href={LINKEDIN_LINK}
              className="bg-white rounded-full p-1 text-black"
              aria-label="Visit CollegeHai on LinkedIn"
            >
              <LinkedinSvg />
            </Link>
          </div>
        </div>
        {/* Copy right section */}
        <div className="flex md:flex-row w-full px-2 mt-8 md:mt-0 text-center md:px-0 md:text-center justify-between items-center gap-4 ">
          <div className="md:hidden text-xs text-center">
            Unifyra Internet Pvt. Ltd. © 2024  
          </div>
          <div className="hidden md:inline-block text-xs">
            Copyrights © CollegeHai Unifyra Internet Pvt Ltd. All rights
            reserved.
          </div>
          <p className="text-xxs">
            <Link href="/terms-and-condition">
              <span className="text-white font-normal">Terms & Condition</span>
            </Link>
            <Link href="/privacy-policy">
              <span className="ml-2 text-white font-normal">
                Privacy policy
              </span>
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
